<script>

//import { createWebHistory, createRouter } from "vue-router";
import DashboardV3 from '../pages/Dashboard-v3.vue';
import UserLoginV3 from '../pages/User-login-v3.vue';
import CalendarDash from '../pages/CalendarDash.vue';
import RegistrationDash from '../pages/RegistrationDash.vue';
import e7tdash from '../pages/e7tdash.vue';
import customersProducts from "@/pages/CustomersProducts.vue";
import ChatSales from '../pages/ChatSales.vue';
import ChatUsers from '../pages/ChatUsers.vue';
import ChatFeedback from '../pages/ChatFeedback.vue';

const routes = [
	{ path: '*', redirect: '/dashboard/' },
  { path: '/dashboard/', component: DashboardV3 },
  { path: '/user/login-v3', component: UserLoginV3 },
  { path: '/calendardash', component: CalendarDash },
  { path: '/registrationdash', component: RegistrationDash },
  { path: '/e7tdash', component: e7tdash },
  { path: '/customersproducts', component: customersProducts },
  { path: '/chatsales', component: ChatSales },
  { path: '/chatusers', component: ChatUsers },
  { path: '/chatfeedback', component: ChatFeedback },
];
/*
routes.beforeEach((to, from) => {
  console.log(to);
  console.log(from);
    })
*/
export default routes;
</script>
